var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"set-container",attrs:{"body-style":{padding: 0}}},[_c('div',{staticClass:"tip-wrapper bg2 flex flex-direction justify-center align-center",on:{"click":_vm.openDrawer}},[_c('i',{staticClass:"el-icon-s-tools"}),_c('div',[_vm._v(" 应用配置 ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }